const values = [
  {
    icon: "ri-shield-check-line",
    title: "Security First",
    desc: "Every line of code is written with your data protection as the top priority.",
  },
  {
    icon: "ri-user-heart-line",
    title: "User-Centric Design",
    desc: "Intuitive interfaces that feel native on every iOS device, with zero learning curve.",
  },
  {
    icon: "ri-speed-up-line",
    title: "Peak Performance",
    desc: "Optimized for speed and efficiency, ensuring minimal battery impact.",
  },
  {
    icon: "ri-refresh-line",
    title: "Continuous Innovation",
    desc: "Regular updates and feature improvements driven by user feedback.",
  },
];

export default function AboutSection() {
  return (
    <section id="about" className="py-32 bg-white">
      <div className="max-w-7xl mx-auto px-8">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-20 items-center">
          {/* Left: image */}
          <div className="relative">
            <div className="relative rounded-2xl overflow-hidden" style={{ aspectRatio: "4/5" }}>
              <img
                src="https://public.readdy.ai/ai/img_res/eb10a735520aafe5ec22587d35ba4ea0.jpg"
                alt="NURA DOO team"
                className="w-full h-full object-cover object-top"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/30 to-transparent" />
            </div>
          </div>

          {/* Right: content */}
          <div>
            <div className="flex items-center gap-3 mb-6">
              <span className="h-px w-8 bg-cyan-400" />
              <span className="text-cyan-500 text-xs uppercase tracking-[0.25em] font-medium">About Us</span>
            </div>
            <h2 className="text-4xl md:text-5xl font-light text-gray-900 leading-tight mb-6" style={{ fontFamily: "'Space Grotesk', sans-serif" }}>
              A team that
              <br />
              <span className="font-semibold">builds with purpose</span>
            </h2>
            <p className="text-gray-500 text-base leading-relaxed mb-4">
              NURA DOO is a dedicated iOS development studio headquartered in Serbia.
              We specialize in building premium mobile applications that tackle real user needs —
              from protecting online privacy to keeping devices running smoothly.
            </p>
            <p className="text-gray-500 text-base leading-relaxed mb-10">
              Our team brings together seasoned engineers, UX designers, and security
              specialists who share one mission: to create iOS apps that users can trust,
              rely on, and love using every single day.
            </p>

            {/* Values grid */}
            <div className="grid grid-cols-2 gap-5">
              {values.map((v) => (
                <div key={v.title} className="flex gap-3 items-start">
                  <div className="w-9 h-9 flex items-center justify-center rounded-lg bg-cyan-50 text-cyan-500 flex-shrink-0">
                    <i className={`${v.icon} text-lg`} />
                  </div>
                  <div>
                    <div className="text-sm font-semibold text-gray-800 mb-0.5">{v.title}</div>
                    <div className="text-xs text-gray-500 leading-snug">{v.desc}</div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
